import { c as _c } from "react/compiler-runtime";
import { storage } from "@/lib/storage";
import { usePropertyInteractionStore } from "@/stores/property-interaction";
import { logger } from "@/utils/logger";
import { useEffect } from "react";
export function useViewedPropertiesInitialization() {
  const initViewedProperties = usePropertyInteractionStore(state => state.initViewedProperties);
  useEffect(() => {
    // Only run once on component mount
    if (typeof window !== "undefined") {
      // Use async storage (IndexedDB) since that's where viewed properties are saved
      storage.getItem<string[]>("viewed_properties").then(viewedIds => {
        if (viewedIds && Array.isArray(viewedIds)) {
          initViewedProperties(viewedIds);
        }
      }).catch(error => {
        logger.error("Failed to load viewed properties from storage:", error);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array - only run once on mount
}
export function useIsPropertyViewed() {
  const $ = _c(2);
  const viewedProperties = usePropertyInteractionStore(_temp);
  let t0;
  if ($[0] !== viewedProperties) {
    t0 = propertyId => viewedProperties instanceof Set ? viewedProperties.has(propertyId) : false;
    $[0] = viewedProperties;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(state) {
  return state.viewedProperties;
}